var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coupons.length)?_c('section',{staticClass:"promos-carousel"},_vm._l((_vm.coupons),function(coupon){return (coupon.active)?_c('div',{on:{"key":coupon.couponCode}},[_vm._v("\n    "+_vm._s(coupon.message)+"\n  ")]):_vm._e()}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }